<template>
    <v-tooltip top>
        <a slot="activator" @click.prevent="$emit('download')" target="_blank" class="az-action-link-icon">
            <i class="fas fa-download" aria-hidden="true"/>
        </a>
        Download
    </v-tooltip>
</template>

<script>
export default {
    name: 'BotaoDownload',
    props: ['uri']
}
</script>

<style scoped lang="stylus">
    @media (max-width 720px)
        .az-action-link-icon i
            font-size 20px
</style>
